module.exports = __webpack_public_path__ + "static/media/mrinalini.0b385a26.webp";